<template>
  <div>
    <v-card
      :loading="loading"
      rounded="lg"
      class="animate__animated animate__fadeInUp"
    >
      <v-toolbar class="elevation-0">
        <v-toolbar-title>
          <lord-icon
            src="https://cdn.lordicon.com/cfoaotmk.json"
            trigger="loop"
            colors="primary:#545454,secondary:#16a9c7"
            style="width: 50px; height: 50px"
          >
          </lord-icon>
          ผู้เรียนแยกตามประเภทวิชา (คน)
          {{ numberWithCommas(countAllstd) }}
          <div v-if="entranceYear" class="caption grey--text">
            ข้อมูล ณ ปีการศึกษา {{ entranceYear }}
          </div>
        </v-toolbar-title>

        <v-spacer></v-spacer>
      </v-toolbar>

      <div id="chart" v-if="loading === false && countAllstd > 0">
        <apexchart
          type="bar"
          height="450"
          :options="chartOptions"
          :series="series"
        ></apexchart>
      </div>
      <v-card-text v-else-if="loading === false" class="text-center grey--text">
        ไม่พบข้อมูลนักเรียนของสถานศึกษานี้
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  name: 'DashboardOvecMasterStdBranch',

  data() {
    return {
      ApiKey: 'HRvec2021',
      loading: true,
      series: [],
      chartOptions: {
        chart: {
          type: 'bar',
        },
      },
      countAllstd: 0,
      entranceYear: null,
    }
  },

  async mounted() {
    await this.queryStudentStatSummary()
  },

  methods: {
    numberWithCommas(x) {
      x = String(x)
      var pattern = /(-?\d+)(\d{3})/
      while (pattern.test(x)) x = x.replace(pattern, '$1,$2')
      return x
    },

    async queryStudentStatSummary() {
      try {
        this.loading = true
        let result = await this.$http
          .post('student_stat_summary_college.php', {
            ApiKey: this.ApiKey,
            college_id: this.college_ID,
          })
          .finally(() => (this.loading = false))

        if (!result.data.status) {
          this.countAllstd = 0
          return
        }

        this.entranceYear = result.data.entranceYear
        const rows = result.data.rows || []

        const byType = {}
        let countall = 0
        rows.forEach((r) => {
          const type = r.subjectTypeNameTh || 'ไม่ระบุประเภทวิชา'
          const cnt = parseInt(r.cnt) || 0
          byType[type] = (byType[type] || 0) + cnt
          countall += cnt
        })
        this.countAllstd = countall

        const labelText = Object.keys(byType)
        const valueshowaf = labelText.map((t) => byType[t])
        this.series = [
          {
            data: valueshowaf,
          },
        ]

        this.chartOptions = {
          chart: {
            type: 'bar',
            height: 450,
          },
          plotOptions: {
            bar: {
              borderRadius: 10,
              barHeight: '100%',
              distributed: true,
              horizontal: true,
              dataLabels: {
                position: 'bottom',
              },
            },
          },
          colors: [
            '#33b2df',
            '#546E7A',
            '#d4526e',
            '#13d8aa',
            '#A5978B',
            '#2b908f',
            '#f9a3a4',
            '#90ee7e',
            '#f48024',
            '#69d2e7',
            '#3EE529',
            '#E565F2',
          ],
          dataLabels: {
            enabled: true,
            textAnchor: 'start',
            style: {
              fontSize: '12px',
              colors: ['#000000'],
            },
            formatter: function (val, opt) {
              return opt.w.globals.labels[opt.dataPointIndex] + ':  ' + val
            },
            offsetX: 50,
            dropShadow: {
              enabled: false,
            },
          },
          stroke: {
            width: 1,
            colors: ['#fff'],
          },
          xaxis: {
            categories: labelText,
          },
          yaxis: {
            labels: {
              show: false,
            },
          },

          tooltip: {
            theme: 'dark',
            x: {
              show: false,
            },
            y: {
              title: {
                formatter: function () {
                  return ''
                },
              },
            },
          },
        }
      } catch (error) {
        console.error('Error fetching data:', error)
        this.countAllstd = 0
      } finally {
        this.loading = false
      }
    },
  },

  computed: {
    college_ID(){
      return this.$route.query.college_ID
    }
  },

}
</script>
